<template>
  <router-view />
</template>

<script>
import { getStatusBarRectCb, isAnb, isAnbIos } from "./environment/anb_api";
import userApi from "@/api/user";
export default {
  name: "app",
  data() {
    return {
      isCityInfoFetched: false, // 标志位，用于跟踪是否已经获取了城市信息
    };
  },
  mounted() {
    try {
      // 同学会app自适应设备顶部状态栏
      if (window.entrance.name === "txh") {
        const height = this.getStatusBarHeight();
        document
          .getElementsByTagName("body")[0]
          .setAttribute("style", "padding-top:" + height + "px;");
      } else if (isAnb() && isAnbIos()) {
        this.setStatusBarPadding();
      }
    } catch (e) {
      console.log(e);
    }
  },
  created() {
    this.isCityInfoFetched = sessionStorage.getItem("isCityInfoFetched");
    if (!this.isCityInfoFetched) {
      if (window.entrance.name == 'lk' || window.entrance.name == 'browser') {
        this.getCityInfoByIp();
      }
      sessionStorage.setItem("isCityInfoFetched", true);
    }
  },
  methods: {
    getStatusBarHeight() {
      const ua = window.navigator.userAgent.toLocaleLowerCase();
      let statusBarHeight = 0;
      const patternHeight = /headerviewheight=(\d+)/;
      const results = ua.match(patternHeight);
      if (results) {
        statusBarHeight = parseInt(results[1], 10);
      }
      return statusBarHeight;
    },
    async getCityInfoByIp() {
      try {
        let res = await userApi.getCityByIp("");
        if (res.data.returnCode == 0) {
          const { data } = res.data;
          let cityInfo = {
            cityId: data.cityId,
            cityName: data.city,
          };
          this.$store.dispatch("changeUserCity", { city: cityInfo });
        }
      } catch (error) {
        console.log("---->", error);
      }
    },
    setStatusBarPadding() {
      getStatusBarRectCb().then((res) => {
        const statusBarHeight = res.data.statusBarHeight;
        const body = document.getElementsByTagName("body")[0];
        body.style.paddingTop = `${statusBarHeight}px`;
        body.style.backgroundColor = "white"; // 添加白色背景
      });
    },
  },
};
</script>
<style>
@import "static/css/style.min.css";
</style>



// WEBPACK FOOTER //
// src/App.vue